<template>
  <div
    class="modal"
    ref="modalRef"
    :class="{ hide: !visible, 'body--scroll': bodyScroll }"
  >
    <section class="fixed-mask" @click.prevent="onMaskClick"></section>
    <section class="modal__body">
      <section class="modal__body__header">
        <h2 class="header__title">{{ title }}</h2>
        <template v-if="closable">
          <span class="header__close" @click="onClose">
            <img
              src="https://static.soyoung.com/sy-pre/close-1682406600722.png"
              alt=""
            /> </span
        ></template>
      </section>
      <section class="modal__body__content">
        <slot></slot>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: "modal",
  model: {
    prop: "visible",
    event: "change",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    closableByMask: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.$nextTick(() => {
          this.recoverModal();
        });
      }
    },
  },
  data() {
    return {
      bodyScroll: false,
    };
  },
  methods: {
    onClose() {
      this.$emit("change", false);
    },
    onMaskClick() {
      if (this.closableByMask) {
        this.onClose();
      }
    },
    recoverModal() {
      if (this.$refs.modalRef && this.bodyScroll) {
        console.log(this.$refs.modalRef.scrollTop, "scrollTop");
      }
    },
  },
};
</script>

<style lang="less">
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  .modal__body {
    position: relative;
    z-index: 999999;
    background-image: linear-gradient(179deg, #f6faff 4%, #ffffff 100%);
    box-shadow: 0 10px 30px 0 rgba(135, 164, 208, 0.2);
    border-radius: 16px;
    width: 1120px;
    max-width: 100%;
    height: 80%;
    padding: 74px 24px 24px;
    box-sizing: border-box;

    &__header {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 100%;
      height: 74px;
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header__title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #121519;
        letter-spacing: 0;
        line-height: 26px;
      }
      .change-modal-style {
        color: #ffffff;
        font-size: 12px;
        line-height: 1;
        padding: 5px 20px;
        border-radius: 50px;
        background: #0044c1;
        cursor: pointer;
      }
      .header__close {
        width: 16px;
        height: 16px;
        cursor: pointer;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    &__content {
      height: 100%;
      overflow: scroll;
      background: rgba(255, 255, 255, 0.7);
      border: 1px solid #e6ebf3;
    }
  }
  &.body--scroll {
    align-items: flex-start;
    padding-top: 40px;
    overflow: scroll;
    .modal__body {
      height: auto;
    }
  }
}
</style>
